/// <amd-module name="typeahead/core/StripingConfiguration"/>

// This interface is to enforce restrictions included
// as keys while running experiment or global rollout
import {Experiment} from "Experiment";

interface IClientConfiguration {
    clients?: string[];
    siteids?: string[];
    tabs?: string[];
    lobs?: string[] | ReadonlyArray<string>;
    packageTypes?: ReadonlyArray<string | undefined>;
    locales?: string[];
    deviceTypes?: string[];
}

export interface IStripingConfiguration extends IClientConfiguration {
    experiment?: Experiment;
    restricted?: IClientConfiguration;
}

export function getExperiments(configurations: IStripingConfiguration[]): Experiment[] {
    if (configurations && configurations.length) {
        return configurations.map((config) => config.experiment)
                             .filter((experiment) =>  !!experiment );
    }
    return [];
}
